<!-- Loading Skeleton -->
<div class="create-order-skeleton" *ngIf="isPageLoading">
  <div class="container">
    <div class="skeleton-header">
      <div class="skeleton-title"></div>
      <div class="skeleton-cart-icon"></div>
    </div>

    <div class="skeleton-search">
      <div class="skeleton-search-bar"></div>
    </div>

    <div class="skeleton-categories">
      <div class="skeleton-category-title"></div>
      <div class="skeleton-category-grid">
        <div class="skeleton-category-item" *ngFor="let item of [1,2,3,4,5,6]">
          <div class="skeleton-category-image"></div>
          <div class="skeleton-category-name"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Main Content -->
<div class="create-order-container" *ngIf="!isPageLoading">
  <div class="container">
    <!-- Header Section -->
    <div class="header-section">
      <div class="header-content">
        <div class="header-info">
          <div class="order-badge">
            <i class="fas fa-utensils"></i>
            <span>Create Order</span>
          </div>
          <h2 class="table-name">{{ getBarcodeName(orderDetails?.barcode_id) }}</h2>
        </div>
        <div class="cart-section">
          <button class="cart-btn" (click)="cart(content2)" [disabled]="isCartLoading">
            <div class="cart-icon-wrapper">
              <i class="fas fa-shopping-cart" *ngIf="!isCartLoading"></i>
              <div class="cart-spinner" *ngIf="isCartLoading"></div>
              <span class="cart-count" *ngIf="cartItemCount > 0">{{ cartItemCount }}</span>
            </div>
            <span class="cart-text">Cart</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Search Container -->
    <!-- Search Container -->
    <div class="search-section">
      <div class="search-card">
        <div class="search-header">
          <i class="fas fa-search search-icon"></i>
          <h3>Find Products</h3>
        </div>
        <div class="search-container">
          <div class="search-wrapper">
            <input
              type="text"
              [(ngModel)]="searchTerm"
              (input)="onSearch($event)"
              (focus)="onSearchFocus()"
              (blur)="onSearchBlur()"
              placeholder="Search for products, brands and categories"
              class="search-input"
              [class.searching]="isLoading" />
            <div class="search-actions">
              <div class="search-spinner" *ngIf="isLoading"></div>
              <button class="search-btn" *ngIf="!isLoading">
                <i class="fas fa-search"></i>
              </button>
              <button class="clear-btn" *ngIf="searchTerm && !isLoading" (click)="clearSearch()">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>

          <!-- Search Dropdown -->
          <div class="search-dropdown" *ngIf="showDropdown" [@slideDown]>
            <!-- Loading State -->
            <div class="search-loading" *ngIf="isLoading">
              <div class="loading-spinner"></div>
              <span>Searching products...</span>
            </div>

            <!-- Results -->
            <div class="search-results" *ngIf="!isLoading && searchResults.length > 0">
              <div class="search-item"
                   *ngFor="let item of searchResults; trackBy: trackByItemId"
                   (click)="selectItem(item)"
                   [@fadeIn]>
                <div class="item-image">
                  <img [src]="item.image || 'icons/default-product.svg'"
                       [alt]="item.name"
                       (error)="onImageError($event)">
                </div>
                <div class="item-details">
                  <div class="item-name">{{item.name}}</div>
                  <div class="item-meta">
                    <span class="item-price">{{item.selling_price | currency: '₦'}}</span>
                    <span class="item-stock" [class.low-stock]="item.quantity < 10">
                      {{item.quantity}} in stock
                    </span>
                  </div>
                  <div class="item-category" *ngIf="item.category">
                    <i class="fas fa-tag"></i>
                    {{item.category.name}}
                  </div>
                </div>
                <div class="item-action">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>
            </div>

            <!-- No Results -->
            <div class="no-results" *ngIf="!isLoading && searchResults.length === 0 && searchTerm" [@fadeIn]>
              <div class="no-results-icon">
                <i class="fas fa-search"></i>
              </div>
              <div class="no-results-text">
                <h4>No products found</h4>
                <p>We couldn't find any products matching "<strong>{{searchTerm}}</strong>"</p>
                <button class="clear-search-btn" (click)="clearSearch()">Clear search</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Categories Section -->
    <div class="categories-section">
      <div class="categories-header">
        <div class="section-title">
          <i class="fas fa-th-large"></i>
          <h3>Browse Categories</h3>
        </div>
        <div class="categories-count" *ngIf="categories.length > 0">
          {{categories.length}} categories
        </div>
      </div>

      <!-- Categories Loading -->
      <div class="categories-loading" *ngIf="isCategoriesLoading">
        <div class="category-skeleton" *ngFor="let item of [1,2,3,4,5,6]">
          <div class="skeleton-image"></div>
          <div class="skeleton-name"></div>
        </div>
      </div>

      <!-- Categories Grid -->
      <div class="categories-grid" *ngIf="!isCategoriesLoading">
        <div class="category-card"
             *ngFor="let category of categories; let i = index; trackBy: trackByCategoryId"
             [@fadeInUp]="i">
          <a [routerLink]="['/create-order/categories/', category.id]" class="category-link">
            <div class="category-image-wrapper">
              <img [src]="category.image"
                   [alt]="category.name"
                   class="category-image"
                   (error)="onImageError($event)">
              <div class="category-overlay">
                <i class="fas fa-arrow-right"></i>
              </div>
            </div>
            <div class="category-info">
              <h4 class="category-name">{{ category.name }}</h4>
              <span class="category-badge" [ngClass]="getRandomColorClass(i)">
                <i class="fas fa-utensils"></i>
              </span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- Cart Modal -->
<ng-template #content2 let-modal>
  <div class="cart-modal">
    <div class="cart-header">
      <div class="cart-title">
        <i class="fas fa-shopping-cart"></i>
        <h3>Your Cart</h3>
        <span class="cart-badge" *ngIf="cartItemCount > 0">{{cartItemCount}}</span>
      </div>
      <button type="button" class="modal-close-btn" (click)="modal.close('Cross click')">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="cart-content">
      <app-create-cart></app-create-cart>
    </div>
  </div>
</ng-template>
